module.exports = __webpack_public_path__ + "static/media/m_eyeshape_almond_blue.ac476d16.png";